import React from 'react'

import Learning from "./Learning"
import { learnings } from "../data"

export default function Learnings() {

  return (
    <div className="learnings">
      <h2 className="title txs">
        Qu'apprendrez vous dans cette formation ?
      </h2>
      <div className="learning_container">
        {learnings.map(learning => (
          <Learning learning={learning} key={Math.random()} />
        ))}
      </div>
    </div>
  )
}
